import { useMemo } from 'react';
import {
  ChildStatus,
  MessageTypeId,
  type MessageTypeRegistration,
  type TimelineEntry,
} from 'src/pages/Conversations/Chat/registry/types';
import { useSmsSessionContext } from './sms-session-context';
import type { SmsSessionGroup } from './sms-session-grouping';
import { SmsSessionRow } from './sms-session-row';

function useItems(): TimelineEntry<SmsSessionGroup>[] {
  const sessionGroups = useSmsSessionContext((v) => v.sessionGroups);

  return useMemo<TimelineEntry<SmsSessionGroup>[]>(
    () =>
      sessionGroups
        .filter((g) => !g.isOpen)
        .map((g) => ({
          type: MessageTypeId.SmsSession,
          timestamp: g.startedAt,
          item: g,
        })),
    [sessionGroups],
  );
}

function useReadiness(): ChildStatus {
  const isLoading = useSmsSessionContext((v) => v.isLoading);
  return isLoading ? ChildStatus.Loading : ChildStatus.Ready;
}

export const smsSessionRegistration: MessageTypeRegistration<SmsSessionGroup> = {
  id: MessageTypeId.SmsSession,
  Row: SmsSessionRow,
  getKey: (item) => item.sessionId,
  useItems,
  useReadiness,
  blockingForInitialRender: false,
};

export default smsSessionRegistration;
